import React from 'react';
import PropTypes from 'prop-types';
import {
  TextField,
  FormGroup,
  withStyles,
} from '@material-ui/core';
import {
  Chip, ItemsWrapper, Wrapper,
} from './styled';

const KEY_ENTER = 13;

const styles = {
  email: {
    '& .MuiInputBase-input': {
      textTransform: 'none',
    },
    '& .MuiChip-label': {
      textTransform: 'none',
    },
  },
};

class TagInput extends React.Component {
  constructor(props) {
    super(props);
    const value = props.field?.value ?? props.value ?? [];
    this.state = {
      addedItems: value || [],
      tagName: '',
      componentError: false,
      componentErrorText: null,
    };
  }

  componentDidUpdate(prevProps) {
    const { reset, field, value } = this.props;

    // Reset externo
    if (prevProps.reset !== reset) {
      this.setItem([]);
    }

    // Sincronizar si el valor externo cambia (ej: resetForm de Formik)
    const externalValue = field?.value ?? value;
    const prevExternalValue = prevProps.field?.value ?? prevProps.value;
    if (
      prevExternalValue !== externalValue
      && externalValue !== undefined
    ) {
      this.setItem(externalValue ?? []);
    }
  }

  setItem = (value) => {
    this.setState({ addedItems: value });
  }

  setTagName = (value) => {
    this.setState({ tagName: value });
  }

  handleOnChange = (items) => {
    const {
      onChange, name, field, form,
    } = this.props;

    // Uso con Formik
    if (field && form) {
      form.setFieldValue(field.name, items);
      form.setFieldTouched(field.name, true, false);
      return;
    }

    // Uso standalone
    if (onChange) {
      onChange({
        target: {
          name,
          value: items,
        },
      });
    }
  }

  onRemove = (tag) => {
    const { addedItems } = this.state;
    const newItems = addedItems.filter(item => item !== tag);
    this.setItem(newItems);
    this.handleOnChange(newItems);
  }

  onAdd = () => {
    const { addedItems, tagName } = this.state;
    if (tagName !== '' && !addedItems.includes(tagName)) {
      const newItems = [...addedItems, tagName];
      this.setItem(newItems);
      this.setTagName('');
      this.handleOnChange(newItems);
    }
  };

  handleKey = (event) => {
    const { keyCode } = event;
    const { tagName, addedItems } = this.state;
    const { email } = this.props;

    if (keyCode === KEY_ENTER) {
      event.preventDefault();

      if (email) {
        const validRegex = /\S+@\S+\.\S+/;
        if (tagName !== '') {
          if (addedItems.includes(tagName)) {
            this.setState({
              componentError: true,
              componentErrorText: 'No se pueden agregar items repetidos',
            });
          } else if (tagName.match(validRegex)) {
            this.onAdd();
            this.setState({
              componentError: false,
              componentErrorText: null,
            });
          } else {
            this.setState({
              componentError: true,
              componentErrorText: 'El email es invalido',
            });
          }
        } else {
          this.setState({
            componentError: false,
            componentErrorText: null,
          });
        }
      } else {
        this.onAdd();
      }
    }
  };

  render() {
    const {
      email,
      error,
      helperText,
      label,
      placeholder,
      style,
      classes,
      field,
      form,
      disabled,
    } = this.props;

    const {
      tagName,
      addedItems,
      componentError,
      componentErrorText,
    } = this.state;

    // Errores desde Formik
    const fieldName = field?.name;
    const hasFormikError = form && fieldName
      ? Boolean(form.touched[fieldName]) && Boolean(form.errors[fieldName])
      : false;
    const formikHelperText = hasFormikError ? form.errors[fieldName] : null;

    // Prioridad: error de componente (validación interna) > error de Formik > error externo (prop)
    const showError = componentError || hasFormikError || error || false;
    const showHelperText = componentError
      ? componentErrorText
      : (hasFormikError ? formikHelperText : helperText);

    return (
      <Wrapper style={style}>
        <FormGroup>
          <TextField
            className={email ? classes.email : null}
            variant="outlined"
            margin="dense"
            autoComplete="off"
            disabled={disabled}
            error={showError}
            helperText={showHelperText}
            value={tagName}
            onChange={({ target }) => this.setTagName(target.value)}
            onKeyDown={this.handleKey}
            label={label}
            placeholder={placeholder}
          />
        </FormGroup>
        <ItemsWrapper>
          {addedItems.map((item, key) => {
            const itemKey = `${item}-${key}`;
            return (
              <Chip
                className={email ? classes.email : null}
                key={itemKey}
                label={item}
                onDelete={disabled ? undefined : () => this.onRemove(item)}
              />
            );
          })}
        </ItemsWrapper>
      </Wrapper>
    );
  }
}

TagInput.defaultProps = {
  placeholder: 'Agregar tags',
  value: [],
  email: false,
  disabled: false,
  error: false,
  helperText: null,
  label: null,
  name: null,
  onChange: null,
  reset: false,
  style: null,
  field: null,
  form: null,
};

TagInput.propTypes = {
  // Props de Formik (inyectadas automáticamente por <Field />)
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.array,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
  }),
  form: PropTypes.shape({
    touched: PropTypes.object,
    errors: PropTypes.object,
    setFieldValue: PropTypes.func,
    setFieldTouched: PropTypes.func,
  }),
  // Props de uso standalone
  classes: PropTypes.oneOfType([PropTypes.object]),
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  reset: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.array]),
  // Booleano para validación de email
  email: PropTypes.bool,
  style: PropTypes.oneOfType([PropTypes.object]),
};

export default withStyles(styles)(TagInput);
